import { MessageDescriptor } from 'react-intl';
import * as mobx from 'mobx';
import { REGISTRATION_APPROVAL_NOTIFICATION_TEXT } from '../../../constants/registration-approval.constants';
import { AccountAdminSettingEntity } from '../common/account-admin-setting.entity';
import { BaseAccountAdminSettingViewModel } from '../common/base-account-admin-setting-form.viewmodel';

class RegistrationApprovalFormVM extends BaseAccountAdminSettingViewModel {
    constructor(
        protected readonly entity: AccountAdminSettingEntity,
    ) {
        super(entity);
    }

    public get notificationMessage(): MessageDescriptor {
        return REGISTRATION_APPROVAL_NOTIFICATION_TEXT;
    }

    public get isCoordinatorDeniedNotificationsEnabled(): boolean {
        return this.entity.coordinatorDeniedNotificationsEnabled;
    }

    public get isRequestAccessCodeRegistrationApprovalEnabled(): boolean {
        return this.entity.requestAccessCodeRegistrationApprovalEnabled;
    }

    public get shouldShowCoordinatorDeniedNotifications(): boolean {
        return this.entity.enabled || this.entity.requestAccessCodeRegistrationApprovalEnabled;
    }

    @mobx.action
    public toggleCoordinatorDeniedNotifications = (): void => {
        this.entity.setCoordinatorDeniedNotificationsEnabled(!this.entity.coordinatorDeniedNotificationsEnabled);
    };

    @mobx.action
    public toggleRequestAccessCodeRegistrationApproval = (): void => {
        this.entity.setRequestAccessCodeRegistrationApprovalEnabled(
            !this.entity.requestAccessCodeRegistrationApprovalEnabled
        );
    };

    public async apiCall(): Promise<void> {
        await this.accountAdminDAO.updateRegistrationApprovalData({
            ...this.entity.getCommonAPIPayload(),
            registrationApprovalEnabled: this.entity.enabled,
            coordinatorDeniedNotificationsEnabled: this.entity.coordinatorDeniedNotificationsEnabled,
            requestAccessCodeRegistrationApprovalEnabled:
                this.entity.requestAccessCodeRegistrationApprovalEnabled,
        });
    }
}

export { RegistrationApprovalFormVM };
